import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import GoBackBar from './go-back-bar';

const RouteBackBar = ({
  buttontext, location, show,
}) => {
  const history = useHistory();

  function handleClick() {
    const path = history.location.pathname.split('/');
    const s = path.slice(0, path.length - 1).join('/');
    history.replace(s);
  }

  const isShowing = show || location.pathname !== '/';
  return (
    <GoBackBar
      isHidden={!isShowing}
      buttontext={buttontext}
      handleClick={handleClick}
    />
  );
};

RouteBackBar.propTypes = {
  /** Text to display on button */
  buttontext: PropTypes.any,
  /** Don't define this */
  location: PropTypes.object.isRequired,
  /** Show/Hide RouteBackBar */
  show: PropTypes.bool,
};

RouteBackBar.defaultProps = {
  buttontext: 'Gå tilbake',
  show: false,
};

export default RouteBackBar;
